import { EntityBase } from "./EntityBase";
import { User } from "./User";
import { Company } from "./Company";
import { Pair } from "../obj/Pair";

export class SellerContract extends EntityBase {
    user: User = null!;
    company: Company = null!;
    name: string = null!;
    termRescission: number = null!;
    terms: string = null!;
    termsDocument: Pair = null!;
    disclosureStatement: string|null = null;
    hash: string = null!;
    dateEntered: Date = null!;
    dateUpdated: Date = null!;
    canBeDeleted: boolean = null!;
}
